import React from 'react';
import { useAuth } from '../../../../store/AuthProvider';
interface HeaderProps {
  month: string;
  year: string;
}
export default function Header({ month, year }: HeaderProps) {
  const { user } = useAuth();
  // Fixed 80px logo dimensions and a plain h1 used to sit shoulder to
  // shoulder in one row, which crowded the institution name into a sliver
  // of space on phones. Stack the row and let the logos/heading scale down
  // fluidly below the sm breakpoint instead.
  const logoStyle: React.CSSProperties = {
    width: 'clamp(48px, 18vw, 80px)',
    height: 'clamp(48px, 18vw, 80px)',
    objectFit: 'contain',
    flexShrink: 0,
  };

  return (
    <div className="px-3 px-sm-4">
      <div className="text-center">
        <h5
          className="text-uppercase py-2 mb-0"
          style={{
            background: '#000',
            color: '#fff',
            fontSize: 'clamp(0.8rem, 3vw, 1.25rem)',
          }}
        >
          <strong>
            {month} {year} - CITIZEN FEEDBACK REPORT
          </strong>
        </h5>
      </div>
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2 py-2">
        {user?.logo && <img src={user.logo} alt="" style={logoStyle} />}

        <h1
          className="text-uppercase text-center mb-0"
          style={{ fontSize: 'clamp(1.1rem, 4vw, 2.25rem)' }}
        >
          <strong>
            {user?.institution?.name || `${user?.firstName} ${user?.lastName}`}
          </strong>
        </h1>
        <img
          src="https://profile-photo-prod-sema.s3.amazonaws.com/SEMA%20LOGO%20PRIMARY.png"
          alt=""
          style={logoStyle}
        />
      </div>
    </div>
  );
}
